// ===================================================================
// KAIXO - OwnChannelsList
// ===================================================================
// Vista 'ownChannels': lista los canales que son propiedad del usuario.
// Al tocar un canal abre su perfil público (misma experiencia que
// visitantes, consistente con la metáfora de "mi latido = mi perfil").
// ===================================================================

import React from 'react';
import { Icons } from '../Icons/Icons';
import ct from './i18n';

export default function OwnChannelsList({
    channels,
    currentUserId,
    loading,
    onCreateClick,
    onOpenProfile,
    onOpenChannel   // fallback cuando no hay inviteCode/handle
}) {
    const mine = (channels || []).filter(c => {
        const ownerId = String(c.owner?._id || c.owner || '');
        return ownerId === String(currentUserId);
    });

    return (
        <div className="v2-body">
            <div className="v2-actions-row">
                <button className="v2-btn-primary" onClick={onCreateClick}>
                    <Icons.Plus size={16} color="white" /> {ct.createBtn}
                </button>
            </div>
            {loading ? (
                <p className="v2-center">{ct.loading}</p>
            ) : mine.length === 0 ? (
                <p className="v2-center v2-dim">
                    {ct.emptyOwn || 'Aún no has creado ningún latido.'}
                </p>
            ) : mine.map(c => (
                <div
                    key={c._id}
                    className="v2-channel-item"
                    onClick={() => {
                        if (c.inviteCode) onOpenProfile(c.inviteCode);
                        else if (c.handle) onOpenProfile('@' + c.handle);
                        else onOpenChannel?.(c);
                    }}
                >
                    <div className="v2-channel-avatar">
                        {c.avatar
                            ? <img src={c.avatar} alt="" loading="lazy" decoding="async" />
                            : c.name?.[0]}
                    </div>
                    <div className="v2-channel-info">
                        <div className="v2-channel-name">{c.name}</div>
                        <div className="v2-channel-preview">{c.status || c.description || '—'}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
